import React, {useCallback, useEffect} from "react";
import classNames from "classnames";
import {ARPhoneInput} from "./index";
import {generateEvent} from "../../utils";
import ARControlList from "./ARControlList";
import {useTranslation} from "react-i18next";
import {getPhoneFormSchema} from "../../schemes";
import {yupResolver} from "@hookform/resolvers/yup";
import {useController, useForm} from "react-hook-form";
import ValidationFeedback from "../../ValidationFeedback";
import {CButton, CInputGroup, CInputGroupAppend} from "@coreui/react";

const ARPhoneSelector = (props) => {
  const {
    id,
    name,
    emptyText,
    className,
    getItemText,
    autoComplete,
    buttonClassName,
    prependComponent,
    externalFormControl
  } = props;

  const {field: {value, onChange}} = useController({name, control: externalFormControl});

  const {t} = useTranslation();
  const phoneInputName = id;
  const phoneFormControl = useForm({
    mode: "onChange",
    resolver: yupResolver(getPhoneFormSchema(phoneInputName)),
    defaultValues: {[phoneInputName]: "7"}
  });

  const {handleSubmit, control, formState: {errors, isSubmitSuccessful}, reset: resetPhoneForm} = phoneFormControl;

  const onAddItemClick = useCallback((formData, event) => {
    const newValue = [...value, formData[phoneInputName]];
    const newEvent = generateEvent({event, newValue});

    onChange(newEvent);
  }, [onChange, value, phoneInputName]);

  const onDeleteItemClick = useCallback(({index, event}) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    const newEvent = generateEvent({event, newValue});

    onChange(newEvent);
  }, [onChange, value]);

  useEffect(() => {
    if (isSubmitSuccessful) {
      resetPhoneForm({[phoneInputName]: "7"});
    }
  }, [isSubmitSuccessful, resetPhoneForm, phoneInputName]);

  return (
    <>
      <ARControlList
        items={value}
        emptyText={emptyText}
        getItemText={getItemText}
        className={classNames(className)}
        prependComponent={prependComponent}
        onActionIconClick={onDeleteItemClick}
        actionIconProps={{
          name: "cilXCircle",
          className: "delete-circle"
        }}
      />
      <CInputGroup
        className="mt-1 mb-3"
        id={`${phoneInputName}_form`}
      >
        <ARPhoneInput
          id={id}
          name={phoneInputName}
          control={control}
          autoComplete={autoComplete}
        />
        <CInputGroupAppend>
          <CButton
            color="primary"
            variant="outline"
            className={classNames("field_right-border-radius", buttonClassName)}
            onClick={handleSubmit((data, event) => onAddItemClick(data, event))}
          >
            {t("form:button.add", "Add")}
          </CButton>
        </CInputGroupAppend>
        <ValidationFeedback error={errors[phoneInputName]}/>
      </CInputGroup>
    </>
  );
};

export default ARPhoneSelector;